<template>
	<v-expansion-panel :elevation="0">
		<v-expansion-panel-header :elevation="0" color="#ffffff" class="font-weight-bold ma-0 pa-0 mb-3" @click="dropdown()">
			<span v-if="items.length > 0">
				<v-badge :value="paginatedItems.length" color="primary" :content="items.length" overlap>
					<span style="padding-right: 1rem">
						{{ title }}
					</span>
				</v-badge>
			</span>
			<span v-else>
				{{ title }}
			</span>
			<v-spacer></v-spacer><v-spacer></v-spacer>
		</v-expansion-panel-header>
		<v-expansion-panel-content color="#ffffff" class="lb-dashboard-expansion-panel-content">
			<div v-if="loading">
				<v-card v-for="index in itemsShown" :key="`loader-${index}`" class="mb-3">
					<v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
				</v-card>
			</div>

			<div v-else>
				<div v-if="hasEvents">
					<v-chip
						v-for="(month, i) of displayedMonths"
						:key="`month-${i}`"
						class="ma-1"
						:color="activeMonths.includes(month) ? 'primary' : ''"
						:close="activeMonths.includes(month) && activeMonths.length > 1"
						close-icon="mdi-close"
						@click="filterEvents(month)"
						@click:close="filterEvents(month, true)"
						>{{ month }}</v-chip
					>
					<!-- Removed Load More button - LBDEV-639 -->
					<!-- <v-chip v-if="showLoadMore" class="ma-1 theme--light" @click="loadMoreRequests()"> Load More </v-chip> -->

					<div class="mt-3"></div>

					<div v-if="type === 'practice-requests-sent'">
						<practice-booking-request-sent-card
							v-for="(set, index) in paginatedItems[page]"
							:key="`request-${index}`"
							v-intersect.once="onViewBookingRequestSentCard"
							:set="set"
						></practice-booking-request-sent-card>
					</div>

					<div v-if="type === 'practice-upcoming-bookings'">
						<practice-booking-card v-for="(booking, index) in paginatedItems[page]" :key="index" :booking="booking"></practice-booking-card>
					</div>

					<div v-if="type === 'practice-applications-received'">
						<applications-received-card v-for="(set, index) in paginatedItems[page]" :key="index" :set="set"> </applications-received-card>
					</div>

					<div v-if="type === 'practice-created-offers'">
						<offer-card v-for="(offer, index) in paginatedItems[page]" :key="index" :offer="offer" class="mb-3"></offer-card>
					</div>

					<div v-if="type === 'practice-booking-history'">
						<booking-history-card v-for="(booking, index) in paginatedItems[page]" :key="index" :booking="booking"></booking-history-card>
					</div>

					<div v-if="type === 'locum-upcoming-bookings'">
						<locum-upcoming-booking-card v-for="(booking, index) in paginatedItems[page]" :key="index" :booking="booking"></locum-upcoming-booking-card>
					</div>

					<div v-if="type === 'locum-booking-requests-received'">
						<locum-booking-request-card v-for="(requestSet, index) in paginatedItems[page]" :key="index" :request-set="requestSet"></locum-booking-request-card>
					</div>

					<div v-if="type === 'locum-offers-near-me'">
						<locum-offers-near-me-card v-for="(offer, index) in paginatedItems[page]" :key="index" :offer="offer"></locum-offers-near-me-card>
					</div>

					<div v-if="type === 'locum-applications-sent'">
						<locum-application-sent-card v-for="(offer, index) in paginatedItems[page]" :key="index" :offer-request-set="offer"></locum-application-sent-card>
					</div>

					<div v-if="type === 'locum-availabilities-set' || type === 'locum-unavailabilities-set'">
						<locum-availability-card
							v-for="(availability, index) in paginatedItems[page]"
							:key="index"
							:availability="availability"
							:index="index"
						></locum-availability-card>
					</div>

					<div v-if="type === 'locum-booking-history'">
						<locum-booking-history-card v-for="(booking, index) in paginatedItems[page]" :key="index" :booking="booking"></locum-booking-history-card>
					</div>
					<!-- Removed Load More button - LBDEV-639 -->
					<!-- <v-row v-if="isFinalPage && showLoadMore" class="mt-1 mb-1">
						<v-col align="center">
							<v-btn rounded color="white" class="black--text" @click="loadMoreRequests()">Load More</v-btn>
						</v-col>
					</v-row> -->
				</div>

				<v-card v-else class="mb-3" flat>
					<v-list-item>
						<v-list-item-content>
							<v-list-item align="center" class="text-center subtitle-2 font-weight-bold">No events found</v-list-item>
							<v-list-item-subtitle v-if="!type.includes('history')" class="text-center">
								<v-btn v-if="type.includes('locum')" dark text color="black" class="ml-0 pl-0 black--text text-none" @click="locumSetAvailability()">
									Set availability <v-icon right>mdi-arrow-right</v-icon>
								</v-btn>
								<v-btn v-if="type.includes('practice')" dark text color="black" class="ml-0 pl-0 black--text text-none" @click="openLocumSearch()">
									Find a locum <v-icon right>mdi-arrow-right</v-icon>
								</v-btn>
							</v-list-item-subtitle>
							<!-- Removed Load More button - LBDEV-639 -->
							<!-- <v-list-item class="subtitle-2 font-weight-bold">
								<v-row>
									<v-col align="center">
										<v-btn rounded color="white" class="black--text" @click="loadMoreRequests()">Load More</v-btn>
									</v-col>
								</v-row>
							</v-list-item> -->
						</v-list-item-content>
					</v-list-item>
				</v-card>
			</div>

			<v-card-actions v-if="this.paginatedItems.length > 1">
				<v-row align="center" justify="space-between" no-gutters>
					<v-col>
						<v-btn class="ma-1" :disabled="page === 0" outlined fab x-small @click="previous">
							<v-icon>keyboard_arrow_left</v-icon>
						</v-btn>
					</v-col>
					<v-col align="center"> Page {{ page + 1 }} of {{ this.paginatedItems.length }} </v-col>
					<v-col align="right">
						<v-btn class="ma-1" :disabled="isFinalPage" outlined fab x-small @click="next">
							<v-icon>keyboard_arrow_right</v-icon>
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-expansion-panel-content>
	</v-expansion-panel>
</template>

<script>
import { bus } from '@/main';
import moment from 'moment';
import store from '@/store';

// PRACTICE CARDS
import PracticeBookingRequestSentCard from '@/components/ui/dashboard/practice/cards/small cards/PracticeBookingRequestSentCard.vue';
import PracticeBookingCard from '@/components/ui/dashboard/practice/cards/small cards/PracticeBookingCard.vue';
import OfferCard from '@/components/ui/dashboard/practice/cards/small cards/OfferCard.vue';
import ApplicationsReceivedCard from '@/components/ui/dashboard/practice/cards/small cards/ApplicationsReceivedCard.vue';
import BookingHistoryCard from '@/components/ui/dashboard/practice/cards/small cards/BookingHistoryCard.vue';

// LOCUM CARDS
import LocumAvailabilityCard from '@/components/ui/dashboard/locum/cards/small cards/LocumAvailabilityCard.vue';
import LocumUpcomingBookingCard from '@/components/ui/dashboard/locum/cards/small cards/LocumUpcomingBookingCard.vue';
import LocumBookingRequestCard from '@/components/ui/dashboard/locum/cards/small cards/LocumBookingRequestCard.vue';
import LocumOffersNearMeCard from '@/components/ui/dashboard/locum/cards/small cards/LocumOffersNearMeCard.vue';
import LocumApplicationSentCard from '@/components/ui/dashboard/locum/cards/small cards/LocumApplicationSentCard.vue';
import LocumBookingHistoryCard from '@/components/ui/dashboard/locum/cards/small cards/LocumBookingHistoryCard.vue';

import { Tracking } from '@/utils';

export default {
	name: 'DashboardDropdownSection',

	components: {
		PracticeBookingRequestSentCard,
		PracticeBookingCard,
		OfferCard,
		LocumAvailabilityCard,
		ApplicationsReceivedCard,
		BookingHistoryCard,
		LocumUpcomingBookingCard,
		LocumBookingRequestCard,
		LocumOffersNearMeCard,
		LocumApplicationSentCard,
		LocumBookingHistoryCard,
	},

	props: {
		title: String,
		type: String,
		itemsShown: Number,
		items: Array,
		eventName: String,
	},

	data: () => ({
		page: 0,
		allItems: [],
		loading: false,
		paginatedItems: [],
		startDate: moment().startOf('month'),
		endDate: moment().add('months', 3).endOf('month'),
		displayedMonths: [],
		activeMonths: [],
	}),

	computed: {
		isFinalPage() {
			return this.paginatedItems.length - 1 === this.page;
		},
		formattedItems() {
			return [];
		},
		hasEvents() {
			return this.paginatedItems.length > 0;
		},
		showLoadMore() {
			return !this.type.includes('history');
		},
	},

	watch: {
		items(newEvents) {
			const clonedEvents = JSON.parse(JSON.stringify(newEvents));
			this.sortItems(clonedEvents);
		},
	},

	mounted() {
		if (this.type.includes('upcoming')) {
			this.startDate = moment();
		}
		this.updateItems();
	},

	methods: {
		dropdown() {
			let Dropdown_title = this.title;
			Tracking.track('DropdownOpen', { Dropdown_title });
		},

		openLocumSearch() {
			window.scrollTo(0, 0);
			bus.$emit('change-context', 'practice-locum-search');
		},

		locumSetAvailability() {
			window.scrollTo(0, 0);
			bus.$emit('change-context', 'locum-set-availability');
		},

		next() {
			this.page += 1;
		},

		previous() {
			this.page -= 1;
		},

		async sortItems(items = [], resetPage = true) {
			const sortedItems = items.sort((setA, setB) => {
				const setADate = setA.event_start_date;
				const setBDate = setB.event_start_date;

				if (setADate && setBDate) {
					return new Date(setADate) - new Date(setBDate);
				}
			});

			const uniqueMonths = [...new Set(sortedItems.map(({ event_start_date }) => (event_start_date ? moment(event_start_date).format('MMMM') : '')))];

			this.displayedMonths = [...this.displayedMonths, ...uniqueMonths];
			this.activeMonths = [...this.activeMonths, ...uniqueMonths];

			this.allItems = [...this.allItems, ...sortedItems];
			this.filterEvents('all', false, resetPage);
		},
		updateItems() {
			const startDate = this.startDate.format('YYYY-MM-DD');
			const endDate = this.endDate.format('YYYY-MM-DD');
			this.$emit(this.eventName, { startDate, endDate });
		},
		bufferItems(items) {
			let buffer = [];
			items.forEach(set => {
				buffer.push(set);
				if (buffer.length == this.itemsShown) {
					this.paginatedItems.push(buffer);
					buffer = [];
				}
			});

			if (buffer.length > 0) {
				this.paginatedItems.push(buffer);
				buffer = [];
			}
		},
		filterEvents(month, removeActiveMonth, resetPage = true) {
			this.loading = true;
			if (month !== 'all') {
				if (removeActiveMonth) {
					this.activeMonths = this.activeMonths.filter(filterMonth => filterMonth !== month);
				} else {
					if (!this.activeMonths.includes(month)) {
						this.activeMonths.push(month);
					}
				}
			}

			const filteredItems = this.allItems.filter(({ event_start_date }) => {
				if (event_start_date) {
					const setMonth = moment(event_start_date).format('MMMM');
					return this.activeMonths.includes(setMonth);
				}
			});

			if (resetPage) {
				this.page = 0;
			}

			this.paginatedItems = [];
			this.bufferItems(filteredItems);

			setTimeout(() => {
				this.loading = false;
			}, 300);
		},
		loadMoreRequests() {
			this.startDate = moment(this.startDate).add('months', 3).endOf('month');
			this.endDate = moment(this.endDate).add('months', 3).endOf('month');
			this.updateItems();
		},
		onViewBookingRequestSentCard(entries, observer, isIntersecting) {
			if (!isIntersecting) {
				return;
			}

			let original = entries[0].target.id;
			let from = original.lastIndexOf('[') + 1;
			let to = original.lastIndexOf(']');
			let id = original.substring(from, to);
			store.commit('POP_CHANNEL_NOTIFICATION', { channel: 'BookingRequestsSent', identity: id });
		},
		dateFormattedMomentjs(date) {
			return date ? moment(date).format('MMM Do YYYY') : '';
		},
	},
};
</script>
